import { post } from '@/util/request'

export default {
	/**
	 * 账号信息
	 * */
    info: query => post(`/system/info`, query),
	/**
	 * 媒体类型、专题排行、来源占比
	 * */
	mediaType: query => post(`/index/mediaType`, query),
    /**
     * 词云
     * */
    wordCloud: query => post(`/index/wordCloud`, query),
    /**
     * 最新舆情
     * */
    newsData: query => post(`/index/newsData`, query),
    /**
     * 属性占比
     * */
    propertyTrend: query => post(`/index/propertyTrend`, query),
    /**
     * 预警舆情
     * */
    warningData: query => post(`/index/warningData`, query),
    /**
     * 专题排行
     * */
    topicRanking: query => post(`/index/topicRanking2`, query),


}
